import {FC} from "react";
import BottomSheet from "../atoms/BottomSheet.tsx";
import {Column, FlexSpace, Row} from "../atoms/Layout.tsx";
import {LANGUAGES} from "../store/languageContext.ts";
import {Text} from "../style/typography.tsx";
import {CloseCircleIcon} from "../atoms/Icon";
import ScrollableSection from "../atoms/ScrollableSection.tsx";
import {Checkbox} from "../atoms/Checkbox.tsx";

interface Props {
    value: string
    onChange: (value: string) => void
    open?: boolean
}

const LanguageSelectMenu: FC<Props> = ({value, onChange, open}) => {
    return <BottomSheet open={open} size={320}>
        <Column gap="16" grow>
            <Row>
                <FlexSpace />
                <CloseCircleIcon size={24} onClick={() => onChange(value)} />
            </Row>
            <ScrollableSection height={248}>
                <Column gap="16">
                    {LANGUAGES.map(language => <div key={language.languageCode} onClick={() => onChange(language.languageCode)}>
                        <Row gap="8">
                            {language.flagEmoji}
                            <Text role="body" size="1" weight={value === language.languageCode ? "bold" : "regular"}>
                                {language.localName}
                            </Text>
                            <FlexSpace />
                            <Checkbox value={value === language.languageCode} />

                        </Row>
                    </div>)}
                </Column>
            </ScrollableSection>
        </Column>
    </BottomSheet>

}

export default LanguageSelectMenu